const renderFindationWidget = ({
  buttonId,
  productUrl,
  productId,
}) => {
  (function() {
    ;window.Modernizr=function(a,b,c){function t(a){i.cssText=a}function u(a,b){return t(prefixes.join(a+";")+(b||""))}function v(a,b){return typeof a===b}function w(a,b){return!!~(""+a).indexOf(b)}function x(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:v(f,"function")?f.bind(d||b):f}return!1}var d="2.6.2",e={},f=b.documentElement,g="modernizr",h=b.createElement(g),i=h.style,j,k={}.toString,l={},m={},n={},o=[],p=o.slice,q,r={}.hasOwnProperty,s;!v(r,"undefined")&&!v(r.call,"undefined")?s=function(a,b){return r.call(a,b)}:s=function(a,b){return b in a&&v(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=p.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(p.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(p.call(arguments)))};return e}),l.postmessage=function(){return!!a.postMessage};for(var y in l)s(l,y)&&(q=y.toLowerCase(),e[q]=l[y](),o.push((e[q]?"":"no-")+q));return e.addTest=function(a,b){if(typeof a=="object")for(var d in a)s(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof enableClasses!="undefined"&&enableClasses&&(f.className+=" "+(b?"":"no-")+a),e[a]=b}return e},t(""),h=j=null,e._version=d,e}(this,this.document);
  
    if(!Modernizr.postmessage) {
      // Can't embed
      return;
    }
    var el = document.getElementById(buttonId);
    var targetProductId = el.getAttribute("data-product-id") || "";
    var targetAPIKey    = el.getAttribute("data-api-key") || "";
    var domain = el.getAttribute("data-findation-url") || "https://findation.com";
    var urlArgs = el.getAttribute("data-mode") || "none"
  
    var bind = function(element, name, callback) {
      if (element.addEventListener) {
        return element.addEventListener(name, callback, false);
      } else {
        return element.attachEvent("on" + name, callback);
      }
    };
  
    var insert = function(element, child) {
      return element.parentNode.insertBefore(child, element);
    };
  
    var findationUrl = function(path){
      // return domain + path + "&host=" + encodeURIComponent(document.location.host) + "&href=" + encodeURIComponent(document.location.href);
      return domain + path + "&host=" + encodeURIComponent(document.location.host) + "&href=" + encodeURIComponent(productUrl);
    }
  
    var buttonFrame = document.createElement("iframe")
    var buttonFrameCss = "background-color: transparent; border: 0px none transparent; overflow: hidden; display: inline-block; visibility: visible; margin: 0px; padding: 0px; height: 0px; width: 0px;";
  
    buttonFrame.id = `findation-button-iframe-${productId}`;
    buttonFrame.style.cssText = buttonFrameCss;
    buttonFrame.title = "Find Your Shade";
    buttonFrame.src = findationUrl("/embed/button_inner?mode=" + urlArgs + "&target_product_id=" + targetProductId + "&api_key=" + targetAPIKey)
  
    insert(el, buttonFrame);
  
    var iframe = document.createElement("iframe");
  
    var iframeCSS = 'position: fixed;\nleft: 0;\ntop: 0;\nwidth: 100%;\nheight: 100%;\nz-index: 9999;\ndisplay: none;';
  
    // Fix for an iframe scrolling issue present on iOS
    var userAgent = window.navigator.userAgent;
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
      var body = document.body,
          html = document.documentElement;
  
      var height = Math.max( body.scrollHeight, body.offsetHeight,
                             html.clientHeight, html.scrollHeight, html.offsetHeight );
      iframeCSS = iframeCSS.replace("position: fixed", "position: absolute; min-height: " + height + "px");
    }
  
    iframe.setAttribute('frameBorder', '0');
    iframe.id = `findation-iframe-${productId}`;
    iframe.setAttribute('allowtransparency', 'true');
    bind(iframe, 'load', function() {
      return iframe.style.visibility = 'visible';
    });
    iframe.style.cssText = iframeCSS;
  
    iframe.src = findationUrl("/widget_searches/new?mode=" + urlArgs + "&target_product_id=" + targetProductId + "&api_key=" + targetAPIKey)
  
    bind(window, "message", function(event) {
      const sourceIframe = Array.from(document.querySelectorAll('iframe')).find(
        frame => frame.contentWindow === event.source
      );

      if(event.data == "overlayClose") {
        iframe.style.display = 'none';
      } else if(event.data == "overlayOpen") {

        if (sourceIframe.id !== `findation-button-iframe-${productId}`) {
          return;
        }

        iframe.style.display = 'block';
        iframe.contentWindow.postMessage("overlayOpen", iframe.src);
  
        // Fix for an iframe scrolling issue present on iOS
        var userAgent = window.navigator.userAgent;
        if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
          window.scrollTo(0,0);
        }
        if(typeof findationWidgetOpen === "function") {
          findationWidgetOpen();
        }

      } else if(event.data == "buttonLoadSuccess") {
        // Now load iframe
        document.body.appendChild(iframe);
        buttonFrame.style.width = "100px";
        buttonFrame.style.height = "20px";
        buttonFrame.style.margin = "0 auto";
      }
    });
  }).call(this);
}

const initResultsSwiper = () => {
  const resultsContainers = document.querySelectorAll('.c-resultBlock')
  if (!resultsContainers) return;

  // append navigation arrows
  const navigationArrows = `
    <div class="arrow arrow--prev">
      <svg xmlns='http://www.w3.org/2000/svg' width='16' height='13' viewBox='0 0 16 13' fill='none'>
        <path d="M4.66602 0.689453L11.0827 6.49971L4.66602 12.31" stroke="black" stroke-width="0.892308" stroke-linecap="round"/>
      </svg>
    </div>
    <div class="arrow arrow--next">
      <svg xmlns='http://www.w3.org/2000/svg' width='16' height='13' viewBox='0 0 16 13' fill='none'>
        <path d="M4.66602 0.689453L11.0827 6.49971L4.66602 12.31" stroke="black" stroke-width="0.892308" stroke-linecap="round"/>
      </svg>
    </div>
  `

  // create a new wrapper
  resultsContainers.forEach(el => {
    el.classList.add('swiper')

    if (!el.querySelector('.arrow--next')) {
      el.insertAdjacentHTML('beforeend', navigationArrows)


      const image = el.querySelector('.c-recommendedProduct img');
      const nextArrow = el.querySelector('.arrow--next');
      const prevArrow = el.querySelector('.arrow--prev');

      // Check if all required elements exist
      if (!image || !nextArrow || !prevArrow) {
        console.warn('Missing required elements for arrow positioning');
        return;
      }

      const positionArrows = () => {
        // Get the container's position
        const container = el.closest('.c-resultPanel-section');
        if (!container) return;

        const containerRect = container.getBoundingClientRect();
        const imageRect = image.getBoundingClientRect();
        const arrowRect = nextArrow.getBoundingClientRect();
        
        // Get container's padding
        const containerPadding = parseInt(window.getComputedStyle(container).paddingTop) || 0;

        // Calculate position relative to the container, accounting for padding and centering vertically
        const imageCenter = imageRect.top + (imageRect.height / 2);
        const containerTop = containerRect.top + containerPadding;
        const arrowOffset = arrowRect.height / 2;
        const topPosition = imageCenter - containerTop - arrowOffset;

        // Apply position
        nextArrow.style.top = `${topPosition}px`;
        prevArrow.style.top = `${topPosition}px`;
      };

      // Position arrows once image is loaded
      if (image.complete) {
        positionArrows();
      } else {
        image.addEventListener('load', positionArrows);
      }

      // Also reposition on window resize
      window.addEventListener('resize', positionArrows);

      setTimeout(() => {
        new Swiper(el, {
          slidesPerView: 1,
          spaceBetween: 10,
          wrapperClass: 'l-products',
          slideClass: 'l-productRow--grid',
          navigation: {
              nextEl: '.c-resultBlock .arrow--next',
              prevEl: '.c-resultBlock .arrow--prev',
          }
        })
      }, 300) // wait a second
    }
  })
}

(function() {
  'use strict';

  window.okeConnectApi = window.okeConnectApi || {};
  window.okeConnectApi.recommendedProductsMounted = async (recommendationSection, products) => {
    // need elements to be rendered - wait for 1 second
    await new Promise(resolve => setTimeout(resolve, 1000));
    initResultsSwiper();

    const renderSwatches = async (variantSelector, product) => {
      if (!product) return;

      const productHandle = product?.url.split('/').pop();
      const response = await fetch(`/products/${productHandle}?sections=product-json`).then(response => response.json());
      const productElement = document.createElement('div');
      productElement.innerHTML = response['product-json'];
      const productJSON = JSON.parse(productElement.querySelector('.shopify-section')?.innerHTML || '{}')?.product;
      const shades = product.options.find(option => option.name === 'Shade')?.values;

      if (shades) {
        const defaultShade = product.options.find(option => option.name === 'Shade')?.values[0];
        const swatch = productJSON.options.find(option => option.name === 'Shade')?.values.find(value => value.name === defaultShade)?.swatch;
        variantSelector.style.setProperty('--selected-swatch-background', `url(${swatch.image})`);

        shades.forEach(shade => {
          const swatch = productJSON.options.find(option => option.name === 'Shade')?.values.find(value => value.name === shade)?.swatch;
          const shadeElement = document.querySelector(`[aria-label="${shade}"]`);
          if (shadeElement && swatch) {
            shadeElement?.addEventListener('click', (e) => {
              variantSelector.style.setProperty('--selected-swatch-background', `url(${swatch.image})`);
            });

            shadeElement.style.setProperty('--swatch-background', `url(${swatch.image})`);
          }
        });
      }
    }

    const variantSelectors = recommendationSection.querySelectorAll('.c-recommendedProduct-variantSelector-opener');
    variantSelectors.forEach(variantSelector => {
      const element = variantSelector.closest('.l-productRow-item');
      const index = Array.from(recommendationSection.querySelectorAll('.l-productRow--grid > .l-productRow-item')).indexOf(element);
      const product = products[index];
      renderSwatches(variantSelector, product);

      variantSelector.addEventListener('click', async (e) => {
        renderSwatches(variantSelector, product);
      });
    });

    products.forEach((product, index) => {
      const productId = product.productId.replace('shopify-', '');

      /**
       * Handle findation widget
       */
      const script = document.createElement('script');
      script.id = `findation-widget-button-${productId}`;
      script.type = 'text/javascript';
      script.src = 'https://www.findation.com/javascripts/widgetv1.js';
      script.async = true;

      script.setAttribute('data-api-key', 'ae8103982b29918d6ce44396073e783ed0b2d6bd0a65347ded4c49dad8ec');

      const productElement = recommendationSection.querySelectorAll(`.l-productRow--grid > .l-productRow-item .c-recommendedProduct-nameAndPrice`)[index];
      productElement.appendChild(script);

      renderFindationWidget({
        buttonId: `findation-widget-button-${productId}`,
        productUrl: `${product.url}?variant=${product.variants[0].variantRemoteId}`,
        productId: productId,
      });
    });
  };
})();